<template>
  <section v-if="loaded">
    <!-- HEADER WITH CONTROLS -->
    <v-toolbar>
      <h1>Display sponsors settings</h1>
      <v-spacer />
      <v-btn color="success" @click="saveDisplaySettings">
        Save changes <v-icon dark right>save</v-icon>
      </v-btn>
      <v-menu offset-y :disabled="noPossibleSponsorsTypes">
        <v-btn color="primary" dark slot="activator">
          Add sponsors section <v-icon dark right>add</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile
            v-for="sectionType in possibleSponsorsTypes"
            :key="`${sectionType.title}-${sectionType.id}`"
            @click="addSponsorsSection(sectionType.id)"
          >
            <v-list-tile-title>
              {{ sectionType.title }}
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <!-- HEADER WITH CONTROLS -->

    <v-layout wrap row>
      <v-flex>
        <v-card class="section">
          <v-layout>
            <v-flex>
              <h5 class="sponsors_subtitle">Display/hide 'become a sponsor' section:</h5>
              <v-switch
                :label="formData.becomeSponsorStatus"
                v-model="formData.becomeSponsorStatus"
                :value="formData.becomeSponsorStatus"
                true-value="Enabled"
                false-value="Disabled"
              ></v-switch>
            </v-flex>
          </v-layout>

          <!--Display settings for sponsor's header at sponsor page (webportal)-->

          <v-layout wrap row>
            <v-flex xs5>
              <content-editor
                label="Header title"
                v-model="formData.headerTitle"
                :error="$v.formData.headerTitle"
              />
            </v-flex>
          </v-layout>
          <!-- TODO background backgroundcolor need to be setting from another place -->
          <!-- Need to say backend that headerBackgourndColorObject isn't necessary -->

          <!-- <v-layout wrap row>
            <v-flex xs5>
              <e-color-picker
                :value="headerBackgourndColorObject"
                @colorChange="setBackgroundColor"
              />
            </v-flex>
          </v-layout> -->
          <v-layout wrap row>
            <v-flex xs5>
              <content-field
                v-model="formData.sponsorSearchPlaceholder"
                label="Search placeholder text"
                :error="$v.formData.sponsorSearchPlaceholder"
              />
            </v-flex>
          </v-layout>

           <v-card
            width="320"
          >
            <div class="grey lighten-2">
              <v-card-media height="130" :src="backgroundImage"/>
            </div>

            <v-card-title><h3>Background image</h3></v-card-title>
            <v-card-actions>
              <v-btn
                flat
                color="success"
                @click="openGallery">Choose</v-btn>
              <v-btn
                flat
                color="error"
                :disabled="!backgroundImage"
                @click="resetBackgroundImage">Reset
              </v-btn>
            </v-card-actions>
          </v-card>
          <div v-if="isBackgroundImageInvalid" class="red&#45;&#45;text">Please select background image</div>

        </v-card>

      </v-flex>
    </v-layout>

    <!-- SPONSOR TYPES SECTIONS -->
    <drag
      :list="displaySettings"
      :options="dragOptions"
      class="sections"
    >
      <v-card
        v-for="section in displaySettings"
        :key="`section-${section.id}`"
        class="section"
      >
        <h2 class="section__title">
          <span class="dragable-icon"><v-icon>swap_vert</v-icon></span>
          <span>
            {{ getSponsorsTypeById(section.id).title }}
          </span>

        </h2>
        <!-- SPONSORS -->
        <drag
          :list="section.sponsors"
          :options="dragOptions"
          class="section__sponsors"
        >
          <v-card
            v-for="(sponsor, sponsorIndex) in section.sponsors"
            :key="`sponsor-${sponsor.id}-in-${sponsorIndex}`"
            :style="getSponsorCardStyles(section.cols)"
            class="section__sponsor"
          >
            <p>
              <span class="dragable-icon"><v-icon>swap_horiz</v-icon></span>
              <v-card-media height="130" :src="getSponsorsLogoUrl(sponsor.id)"/>
              <span>
                {{ getSponsorTitle(sponsor.id) }}
              </span>
            </p>
            <div>
              <v-divider />
              <v-select
                :items="publishCategories"
                v-model="sponsor.displayStatus"
                item-value="value"
                item-text="text"
                label="Visible in"
              />
              <v-btn color="error" small @click="removeSponsorFromSection(sponsorIndex, section.id)">Remove</v-btn>
            </div>
          </v-card>
        </drag>
        <!-- SPONSORS -->
        <v-divider />
        <div class="section__controls">
          <v-btn color="error" @click="removeSponsorsSection(section.id)">Delete</v-btn>
          <v-menu offset-y :disabled="noPossibleSponsorsForSection(section.id)">
            <v-btn color="primary" dark slot="activator">
              Add sponsor<v-icon dark right>add</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile
                v-for="sponsor in possibleSponsorsForSection(section.id)"
                :key="`${sponsor.company}-${sponsor.id}`"
                @click="addSponsorToSection(sponsor.id, section.id)"
              >
                <v-list-tile-title>
                  {{ sponsor.company }}
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <div v-if="section.cols" class="section__controls-cols">
            <v-select
              :items="sectionTypes"
              item-text="title"
              item-value="cols"
              v-model="section.cols"
              label="Type"
            />
          </div>
          <div v-if="section.rowsLimit" class="section__controls-rows">
            <v-text-field
              v-model="section.rowsLimit.desktop"
              label="Desktop homepage rows to show"
              type="number"
              class="section__controls-row"
            />
            <v-text-field
              v-model="section.rowsLimit.mobile"
              label="Mobile homepage rows to show"
              type="number"
              class="section__controls-row"
            />
          </div>
        </div>
      </v-card>
    </drag>
    <!-- SPONSOR TYPES SECTIONS -->
    <v-dialog v-model="isGalleryVisible">
      <galleries-list :modalView="true" @pickedImage="setBackgroundImage"/>
    </v-dialog>

  </section>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { pathOr, clone, path } from 'ramda'
  import GalleriesList from '@/components/pages/Gallery/GalleriesList'
  import ContentField from '@/components/shared/ContentField'
  import EColorPicker from '@/components/shared/EColorPicker'
  import { required } from 'vuelidate/lib/validators'

  export default {
    name: 'SponsorsDisplay',
    components: {
      GalleriesList,
      ContentField,
      EColorPicker
    },
    data () {
      return {
        loaded: false,
        isGalleryVisible: false,
        formData: {
          headerTitle: '',
          headerBackgroundColor: '#fff',
          headerBackgroundImageId: '',
          sponsorSearchPlaceholder: '',
          becomeSponsorStatus : ''
        },
        backgroundImage: null,
        displaySettings: [],
        dragOptions: {
          ghostClass: 'before-drag-drop'
        },
        publishCategories: [{
          value: 0,
          text: 'Everywhere'
        },{
          value: 1,
          text: 'Only VVF'
        },{
          value: 2,
          text: 'Only physical'
        }],
        sectionTypes: [
          { title: 'Main', cols: 5 },
          { title: 'Secondary', cols: 10 }
        ]
      }
    },
    validations: {
      formData: {
        headerTitle: { required },
        // headerBackgroundColor: { required },
        headerBackgroundImageId: { required },
        sponsorSearchPlaceholder: { required }
      }
    },
    computed: {
      ...mapGetters([
        'sponsorsList',
        'sponsorsTypeList',
        'getSponsorsTypeById',
        'getSponsorById',
        'getSettings',
        'getImgUrl'
      ]),
      possibleSponsorsTypes () {
        const allowed = this.sponsorsTypeList.filter(type => !this.displaySettings.find(section => section.id === type.id))
        return allowed.filter(type => !this.noPossibleSponsorsForSection(type.id))
      },
      noPossibleSponsorsTypes () {
        return !this.possibleSponsorsTypes.length
      },
      getSponsorsSettings () {
        return path(['sponsorsSetting'], this.getSettings)
      },
      headerBackgourndColorObject () {
        return { hex: this.getSponsorsSettings.headerBackgroundColor }
      },
      isBackgroundImageInvalid () {
        return this.$v.formData.headerBackgroundImageId.$invalid && this.$v.formData.$dirty
      }
    },
    watch: {
      getSponsorsSettings (val) {
        this.setInitialDisplaySettings(path(['displaySettingsObject'], val))
      }
    },
    methods: {
      ...mapActions([
        'fetchSponsorsList',
        'fetchSponsorTypesList',
        'fetchGeneralSettings',
        'editSponsorsSettings',
        'setImageUrl'
      ]),
      getSponsorsLogoUrl (sponsorId) {
        return pathOr('', ['logoUrl'], this.getSponsorById(sponsorId))
      },
      getSponsorTitle (sponsorId) {
        return pathOr('', ['company'], this.getSponsorById(sponsorId))
      },
      getSponsorCardStyles (sectionColsNumber) {
        const width = 100 / sectionColsNumber
        const margin = '10px'
        return {
          width: `calc(${width}% - ${margin})`,
          marginRight: margin,
          marginTop: margin
        }
      },
      setInitialDisplaySettings (settings) {
        let loadedSettings = clone(pathOr([], ['sections'], settings))
        loadedSettings = loadedSettings.filter(section => {
          if (pathOr(false, ['sponsors'], section)) {
            section.sponsors = section.sponsors.filter(sponsor => {
              return !!this.getSponsorById(sponsor.id) || sponsor.id === 'empty'
            })
          }
          return !!this.getSponsorsTypeById(section.id)
        })
        this.displaySettings = [...loadedSettings]
        this.loaded = true
      },
      async saveDisplaySettings () {
        this.$v.$touch()
        if (this.$v.formData.$invalid) return
        this.saveNewOrder()

        const payload = {
          ...this.formData,
          displaySettings: {
            sections: this.displaySettings
          }
        }
        await this.editSponsorsSettings(payload)
        this.fetchGeneralSettings()
      },
      addSponsorsSection (sectionTypeId) {
        this.displaySettings = [...this.displaySettings, {
          id: sectionTypeId,
          sponsors: [],
          order: this.displaySettings.length,
          cols: 10,
          rowsLimit: {
            desktop: 2,
            mobile: 5
          }
        }]
      },
      removeSponsorsSection (sectionTypeId) {
        this.displaySettings = this.displaySettings.filter(section => section.id !== sectionTypeId)
      },
      saveNewOrder () {
        const orderedDisplaySettings = this.displaySettings.map((section, i) => {
          section.order = i
          section.sponsors.map((sponsor, j) => {
            sponsor.order = j
          })
          return section
        })

        this.displaySettings = [...orderedDisplaySettings]
      },
      possibleSponsorsForSection (sectionId) {
        const alreadyUsedSections = pathOr([], ['sponsors'], this.displaySettings.find(section => section.id === sectionId))
        const allowedSponsors = this.sponsorsList.filter(sponsor => {
          return sponsor.sponsorTypesIds ? sponsor.sponsorTypesIds.includes(sectionId) : false
        })
        const possibleSponsorsForSection = allowedSponsors.filter(sponsor => !alreadyUsedSections.find(usedSponsor => usedSponsor.id === sponsor.id))
        return possibleSponsorsForSection
      },
      addSponsorToSection (sponsorId, sectionId) {
        const section = this.displaySettings.find(section => section.id === sectionId)
        section.sponsors = [...section.sponsors, {
          id: sponsorId,
          displayStatus: 0,
          order: section.sponsors.length
        }]
      },
      removeSponsorFromSection (sponsorIndex, sectionId) {
        const section = this.displaySettings.find(section => section.id === sectionId)
        const newSponsors = pathOr([], ['sponsors'], section).filter((sponsor, i) => i !== sponsorIndex)
        section.sponsors = [...newSponsors]
      },
      noPossibleSponsorsForSection (sectionTypeId) {
        return !this.possibleSponsorsForSection(sectionTypeId).length
      },
      setBackgroundColor ({ hex }) {
        this.formData.headerBackgroundColor = hex
      },
      setBackgroundImage (imageItem) {
        this.backgroundImage = imageItem.imagesUrls.originalImageUrl
        this.formData.headerBackgroundImageId = imageItem.id
        this.isGalleryVisible = false
      },
      openGallery () {
        this.isGalleryVisible = true
      },
      resetBackgroundImage () {
        this.formData.headerBackgroundImageId = ''
        this.backgroundImage = ''
      }
    },
    async created () {
      await this.fetchSponsorTypesList()
      await this.fetchSponsorsList({
        itemsOnPage: 9999,
        filter: true,
        fieldName: 'Status',
        operatorName: 'Equals',
        fieldVal: 'Published'
      })
      await this.fetchGeneralSettings()
      if (this.getSponsorsSettings) {
        this.setInitialDisplaySettings(path(['displaySettingsObject'], this.getSponsorsSettings))
      }
      this.formData = clone(this.getSponsorsSettings)
      await this.setImageUrl(this.formData.headerBackgroundImageId)
      this.backgroundImage = this.getImgUrl
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .menu--disabled {
    opacity: 0.3;
  }

  /deep/ .btn {
    margin-right: 0;
  }

  /deep/ .btn.error {
    margin-left: 0;
  }

  .section {
    margin: 20px 0;
    padding: 15px;
    cursor: move;
    cursor: grab;

    &__controls {
      display: flex;
      align-items: center;
      margin-bottom: -25px;

      &-cols {
        width: 150px;
        margin-left: 10px;
        margin-top: 13px;
      }

      &-rows {
        display: flex;
        margin-top: 13px;
      }

      &-row {
        width: 290px;
        margin-left: 10px;
      }
    }

    &__sponsors {
      margin: 10px 0;
      padding: 10px 0;
      min-width: 1150px; // to save sponsors display grid
    }

    &__sponsor {
      display: inline-flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 5px;
      min-width: 100px;
      overflow: hidden;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .dragable-icon {
    margin-right: 1%;
  }

  .before-drag-drop {
    opacity: 0.35;
    background: lightgray;
  }

  .sponsors_subtitle {
    color: grey;
    font-weight: 300;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Sponsors/Display/index.vue